import { render, staticRenderFns } from "./FlexDetail.vue?vue&type=template&id=d4f8b614&scoped=true"
import script from "./FlexDetail.vue?vue&type=script&lang=js"
export * from "./FlexDetail.vue?vue&type=script&lang=js"
import style0 from "./FlexDetail.vue?vue&type=style&index=0&id=d4f8b614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f8b614",
  null
  
)

export default component.exports